export function getCustomStyles() {
    return {
        control: (provided, state) => ({
            ...provided,

            borderRadius: "var(--rounded-btn)",
            backgroundColor: state.isDisabled ? "var(--color-gray-200)" : "var(--color-field)",
            border: state.isFocused ? 0 : 0,
            // // This line disable the blue border
            boxShadow: state.isFocused ? "0 0 0 1px var(--color-primary)" : 0,
            minHeight: "34px",
            transition: "none",
        }),
        indicatorSeparator: (provided, state) => ({
            ...provided,
            backgroundColor: "var(--color-gray-300)",
        }),

        dropdownIndicator: (provided, state) => ({
            ...provided,
            height: "34px",
            color: state.isDisabled ? "var(--color-gray-200)" : "var(--color-gray-700)"
        }),

        clearIndicator: (provided, state) => ({
            ...provided,
            color: "var(--color-gray-900)",
            "&:hover": {
                cursor: "pointer",
                color: "var(--color-gray-400)",
            }
        }),

        option: (provided, state) => ({
            ...provided,
            color: state.isFocused ? '#fff' : '',
            fontWeight: state.isSelected ? 700 : '',
            background: state.isFocused ? "#00365a" : "transparent",
            cursor: "pointer",
            '&:hover': {
                color: '#fff',
                background: "#00365a"
            }
        }),
        menuPortal: base => ({ ...base, zIndex: 9999 }),
        menu: (provided, state) => ({
            ...provided,
            background: "var(--color-field)",
            color: "var(--color-gray-900)",
            width: "100%",
            marginTop: "0px",
            zIndex: 100,
        }),

        input: (provided, state) => ({
            ...provided,
            color: "var(--color-gray-900)"
        }),

        singleValue: (provided, state) => ({
            ...provided,
            color: "var(--color-gray-900)",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "calc(100% - 2px)",
        }),
        valueContainer: (provided, state) => ({
            ...provided,
             padding: "0.20rem 0.75rem;"
        }),
        container: (provided, state) => ({
            ...provided,
        })
    }
}
